import React, { useContext, useEffect, useRef, useState } from 'react';

import {
  CancelAllButton,
  CancelButton,
  ChaseButton,
  TradeDetailListSection,
  TradeText,
} from './styles';

import EmptyPosition from '@/app/components/EmptyPosition';
import { formatDecimal4Truncate } from '@/utils/formatDecimal';
import { AuthCheckText } from '@app/components';
import { useToken } from '@app/hooks';
import CNoDataFound from '@components/Common/CNoDataFound';
import EditCheckPositionModal from '@components/EditCheckPositionModal';
import { Table, Tag, message } from 'antd';
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { View } from '../../../../../styles/reactnative';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import EntryTime from '../../../../components/EntryTime';
import KrwPrice from '../../../../components/KrwPrice';
import { COLORS } from '../../../../constants';
import { SETTING_TYPE_SYSTEM } from '../../../../constants/SETTING';
import { useCiTradeWebSocketStore } from '../../../../hooks/ciTradeWebsocketStore';
import { useExchangeStore } from '../../../../hooks/trade/exchangeStore';
import { useIndexPrice } from '../../../../hooks/trade/indexprice';
import { useMitOrder } from '../../../../hooks/trade/mitorder';
import { useTradeModalStore } from '../../../../hooks/trade/modalStore';
import { useTradeApi } from '../../../../hooks/trade/tradeApi'; // ✅ Context 기반 API Hook 사용
import { useTradePosition } from '../../../../hooks/trade/tradePosition';
import { useTradeSetting } from '../../../../hooks/trade/tradeSetting';
import useTradeStore from '../../../../hooks/trade/tradeStore';
import { getSetting, useSetting } from '../../../../hooks/user/mysetting';
import ContractsColumn from '../Columns/ContractsColumn';
import TPSLEDIT from '../TPSLEDIT';
import useScrollLayout from '../useScrollLayout';

// 헤더 스타일 (TradePositionsTable과 동일)
const headerStyle = {
  fontFamily: 'NanumSquareRound',
  fontSize: 12,
  color: '#b3b5bd',
  letterSpacing: '-0.24px',
  whiteSpace: 'nowrap' as const,
};

// 셀 데이터 공통 스타일
const cellStyle = {
  letterSpacing: 0,
  minWidth: 90,
  whiteSpace: 'nowrap' as const,
  height: 17,
  alignItems: 'flex-end' as const,
  color: '#fff',
  fontFamily: 'NanumSquareRound',
  fontSize: 12,
};

// 숫자 강조 스타일
const cellStyleBold = {
  fontWeight: 700,
  fontFamily: 'NanumSquareRound',
  letterSpacing: 0,
  whiteSpace: 'nowrap' as const,
  color: '#fff',
  lineHeight: 'normal',
};

const TradeActiveTable = ({ parentHeight = 300, isMobile = false }) => {
  const { data: token } = useToken();
  const { cancelOrderNoLogout, updateOrder } = useTradeApi(); // ✅ Demo/Real 자동 선택
  const { textw, content, header, textsilver, PrimaryBg, PrimaryBorder } =
    useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  const [shareData, setShareData] = React.useState<any>(null);

  const [closeAll, setCloseAll] = React.useState(false);

  const { mutate: mutateModalStore, data: modalStore } = useTradeModalStore();

  // Chase 기능을 위한 state
  const [chaseModalOpen, setChaseModalOpen] = React.useState(false);
  const [chaseOrderId, setChaseOrderId] = React.useState<number | null>(null);
  const [chaseOrderPrice, setChaseOrderPrice] = React.useState(0);
  const [chaseOrderItem, setChaseOrderItem] = React.useState<any>({});
  const [chaseLongShort, setChaseLongShort] = React.useState('L');

  // 현재가 가져오기
  const currentMarketPrice = useCiTradeWebSocketStore((s) => s.tradePrice);

  const { data: tradeStore } = useTradeStore();

  const { data: setting, updateSetting } = useSetting(SETTING_TYPE_SYSTEM);
  const equivshow = getSetting(setting, 'EQUIVSHO', 1) == 1 ? true : false;

  const { getPrice } = useIndexPrice(tradeStore?.ep_id || 0);

  const { data: tradeSetting } = useTradeSetting(tradeStore?.ep_id);

  const { EPs } = useExchangeStore();
  const { data, orderlist, mutate } = useTradePosition();

  const { data: mitdata, mutate: mutateMit } = useMitOrder();

  let list = orderlist?.length > 0 ? [...orderlist] : [];

  const [mit, setMit] = useState<any>([]);

  list = [...mit, ...list];

  const { needsScroll, headerHeight } = useScrollLayout(
    containerRef,
    list,
    parentHeight
  );

  const orderType = tradeStore?.main_sub || 'M';

  //console.log('itemitemitem', list)

  useEffect(() => {
    const keys = Object.keys(mitdata || []);
    const allMitList: any = [];

    for (const key of keys) {
      if (key == 'NO') continue;

      const mitlist: any = [];
      const item = mitdata[key];

      item?.map((mit: any) => {
        const temp = {
          status: 10,
          exchange_pairs_id: parseInt(key?.replace('MIT', '')),
          leverage: tradeSetting?.leverage || 1,
          limit_market: mit.limit_market == 'CL' ? 'L' : 'M',
          order_price: mit.price,
          trigger_price: mit.trigger_price,
          trigger_type: mit.trigger_type,
          long_short: mit.longshort,
          amount: mit?.amount,
          created_at: mit?.created_at,
        };
        allMitList.push(temp);
      });
      setMit(allMitList);
    }

    return () => {
      setMit([]);
    };
  }, [mitdata]);

  // TP/SL 의 내용은 미체결주문에서 보여주지 않기로 해서 주석 처리
  // data?.map((item: any) => {
  // 	if (item?.tpsl) {
  // 		const TPSL = item?.tpsl?.[0];

  // 		if (TPSL) {
  // 			if (+TPSL?.tp != 0) {
  // 				list = [
  // 					{
  // 						...item,
  // 						posid: item?.id,
  // 						posprice: item?.price,
  // 						poslongshort: item?.long_short,
  // 						status: 1,
  // 						limit_market: "L",
  // 						long_short: item?.long_short == "L" ? "S" : "L",
  // 						order_price: +TPSL?.tp,
  // 						type: "TP",
  // 						tpsltype: TPSL?.tp + " " + TPSL?.tptype,
  // 						tpsl: TPSL,
  // 					},
  // 					...list,
  // 				];
  // 			}
  // 			if (+TPSL?.sl != 0) {
  // 				list = [
  // 					{
  // 						...item,
  // 						posid: item?.id,
  // 						posprice: item?.price,
  // 						poslongshort: item?.long_short,
  // 						status: 1,
  // 						limit_market: "L",
  // 						long_short: item?.long_short == "L" ? "S" : "L",
  // 						order_price: +TPSL?.sl,
  // 						type: "SL",
  // 						tpsltype: TPSL?.sl + " " + TPSL?.sltype,
  // 						tpsl: TPSL,
  // 					},
  // 					...list,
  // 				];
  // 			}
  // 		}
  // 	}
  // });

  if (modalStore?.iscurrent) {
    list = list?.filter(
      (item: any) => item?.exchange_pairs_id == tradeStore?.ep_id
    );
  }

  // 전체 취소 버튼 온클릭 핸들러라고 생각하면 됩니다.
  useEffect(() => {
    if (!closeAll) return;

    const cancelAllOrders = async () => {
      try {
        const cancelPromises: Promise<any>[] = [];

        // ✅ Demo/Real 자동 선택
        // 일반 주문 취소 요청 수집
        orderlist?.forEach((item: any) => {
          cancelPromises.push(
            cancelOrderNoLogout({
              orderid: item?.id,
            })
          );
        });

        // MIT 주문 취소 요청 수집
        mit?.forEach((item: any) => {
          const temp = mitdata['MIT' + item?.exchange_pairs_id]?.filter(
            (mit: any) =>
              !(
                mit.limit_market == 'C' + item?.limit_market &&
                +mit.price == +item?.order_price &&
                mit.longshort == item?.long_short
              )
          );

          // MIT 스토어 업데이트 (동기 작업)
          mutateMit(temp, item?.exchange_pairs_id);

          // MIT 주문 취소 API 호출
          cancelPromises.push(
            cancelOrderNoLogout({
              orderid: item?.id,
              is_triggered: !!item?.trigger_type,
            })
          );
        });

        // 모든 취소 요청을 병렬로 실행하고 완료 대기
        await Promise.all(cancelPromises);

        // 모든 작업 완료 후 데이터 갱신
        mutate();
        message.success(t('allOrdersCancelled'));
      } catch (error) {
        console.error('Cancel all orders error:', error);
        message.error(t('failedToCancelAllOrder'));
      } finally {
        setCloseAll(false);
      }
    };

    cancelAllOrders();
  }, [closeAll]);

  // Chase 기능 핸들러
  const handleChaseOrder = async (item: any) => {
    const EP = EPs?.find((ep: any) => +ep.id === +item?.exchange_pairs_id);
    const currentPrice = getPrice(item?.exchange_pairs_id);

    // MIT 조건부 주문이면 처리하지 않음
    if (item?.status === 10) {
      message.warning(
        t('chaseNotAvailableForConditionalOrder') ||
          'Chase는 조건부 주문에서 사용할 수 없습니다'
      );
      return;
    }

    // 시장가 주문이면 처리하지 않음
    if (item?.limit_market !== 'L') {
      message.warning(
        t('chaseOnlyForLimitOrder') || 'Chase는 지정가 주문에만 사용 가능합니다'
      );
      return;
    }

    // 주문 확인 설정 확인 (skip이 true면 주문 확인 안 함)
    if (modalStore?.skip) {
      // 바로 API 호출
      try {
        const orderParams = {
          order_id: item?.id,
          price: currentPrice,
        };

        const result = await updateOrder(orderParams);

        if (result?.result?.success) {
          mutate();
          setTimeout(() => {
            mutate();
          }, 500);
          message.success(t('ordersuccess'));
        } else {
          message.error(t(result?.result?.message + ''));
        }
      } catch (error) {
        message.error(t('failedToUpdateOrder') || '주문 수정에 실패했습니다');
      }
    } else {
      // 모달 띄우기
      setChaseOrderId(item?.id);
      setChaseOrderPrice(currentPrice);
      setChaseOrderItem(item);
      setChaseLongShort(item?.long_short);
      setChaseModalOpen(true);
    }
  };

  return (
    <TradeDetailListSection ref={containerRef}>
      <EditCheckPositionModal
        open={chaseModalOpen}
        setOpen={setChaseModalOpen}
        long_short={chaseLongShort}
        rawOrderPrice={chaseOrderPrice}
        orderId={chaseOrderId}
        orderItem={chaseOrderItem}
      />
      {token ? null : <AuthCheckText />}

      {list?.length ? (
        <Table
          showHeader={true}
          bordered={false}
          dataSource={list}
          columns={[
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('contracts')}</span>,
              dataIndex: 'contracts',
              align: 'left',
              key: 'contracts',
              render: (text: any, item) => <ContractsColumn item={item} />,
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('qty')}</span>,
              dataIndex: 'amount',
              key: 'amount',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );
                const coin = EP?.pairs?.split('/')[0];
                const currentPrice = getPrice(item?.exchange_pairs_id);
                return (
                  <TradeText
                    style={{
                      ...cellStyleBold,
                      justifyContent: 'flex-start',
                    }}
                  >
                    {orderType === 'M'
                      ? BigNumber(item?.amount)
                          .multipliedBy(item?.leverage)
                          .toFormat(4)
                      : BigNumber(item?.amount)
                          .multipliedBy(currentPrice)
                          .multipliedBy(item?.leverage)
                          .toFormat(4)}{' '}
                    {orderType === 'M' ? coin : 'USDT'}
                  </TradeText>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('orderPrice')}</span>,
              dataIndex: 'open_price',
              key: 'open_price',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );

                // Time In Force 정보 (지정가 주문이고 MIT가 아닐 때만)
                const timeInForce =
                  item?.time_in_force || item?.data?.timeInForce;
                const gtdExpiry = item?.gtd_expiry || item?.data?.gtdExpiry;
                const showTif =
                  item?.limit_market === 'L' && item?.status !== 10;

                return (
                  <TradeText
                    style={{
                      ...cellStyle,
                      justifyContent: 'flex-start',
                    }}
                  >
                    {item?.status == 10
                      ? item?.limit_market == 'L'
                        ? t('climit') +
                          ' (' +
                          BigNumber(item?.order_price).toFormat(EP?.dp || 3) +
                          ')'
                        : t('cmarket')
                      : ''}

                    {item?.status == 10 ? (
                      <span>
                        {item?.trigger_type == 'BIG' ? '<=' : '>='}
                        {BigNumber(item?.trigger_price).toFormat(EP?.dp || 3)}
                      </span>
                    ) : (
                      <span>
                        {item?.limit_market == 'L'
                          ? BigNumber(item?.order_price).toFormat(EP?.dp || 3)
                          : t('market')}
                      </span>
                    )}

                    {/* Time In Force 표시 */}
                    {showTif && timeInForce && (
                      <div
                        style={{
                          fontSize: 11,
                          color:
                            timeInForce === 'GTD' ? COLORS.primary : textsilver,
                          marginTop: 2,
                        }}
                      >
                        {timeInForce === 'GTD' && gtdExpiry
                          ? `GTD ${dayjs(gtdExpiry).format('MM/DD HH:mm')}`
                          : timeInForce}
                      </div>
                    )}
                  </TradeText>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('markPrice')}</span>,
              dataIndex: 'mark_price',
              key: 'mark_price',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );

                return (
                  <TradeText
                    style={{
                      ...cellStyle,
                      justifyContent: 'flex-start',
                    }}
                  >
                    {BigNumber(getPrice(item?.exchange_pairs_id)).toFormat(
                      EP?.dp || 3
                    )}
                  </TradeText>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('margin')}</span>,
              dataIndex: 'margin',
              key: 'margin',
              align: 'left',
              render: (text: any, item) => {
                const EP = EPs?.find(
                  (item2: any) => +item2.id == +item?.exchange_pairs_id
                );
                const currency = EP?.pairs?.split('/')[1];
                return (
                  <div style={{}}>
                    <KrwPrice
                      price={formatDecimal4Truncate(item?.margin)}
                      currency={currency}
                      color={false}
                      equiv={false}
                      dp={2}
                    />
                  </div>
                );
              },
            },
            {
              width: '14.2%',
              title: <span style={headerStyle}>{t('orderTime')}</span>,
              dataIndex: 'created_at',
              key: 'created_at',
              align: 'left',
              render: (text: any, item) => {
                return (
                  <EntryTime
                    time={item?.created_at}
                    style={{ justifyContent: 'flex-start', fontSize: 12 }}
                  />
                );
              },
            },
            {
              title: (
                <CancelAllButton
                  size="small"
                  onClick={() => {
                    setCloseAll(true);
                  }}
                >
                  {t('entire')} {t('cancel')}
                </CancelAllButton>
              ),
              dataIndex: 'close_by',
              key: 'close_by',
              align: 'left',
              render: (text: any, item) => {
                if (item?.type == 'TP' || item?.type == 'SL') {
                  return (
                    <View style={{ flexDirection: 'row' }}>
                      <Tag>{t(item?.type)}</Tag>
                      <TPSLEDIT
                        posid={item?.posid}
                        tpsl={item?.tpsl}
                        price={item?.posprice}
                        amount={item?.leverage}
                        long_short={item?.poslongshort}
                        leverage={item?.leverage}
                        margin={item?.margin}
                      />
                    </View>
                  );
                }
                return (
                  <div style={{ display: 'flex', gap: 4 }}>
                    {/* Chase 버튼 - 지정가 주문이고 MIT가 아닐 때만 표시 */}
                    {item?.limit_market === 'L' && item?.status !== 10 && (
                      <ChaseButton
                        size="small"
                        onClick={() => handleChaseOrder(item)}
                      >
                        {t('chase')}
                      </ChaseButton>
                    )}

                    {/* 취소 버튼 */}
                    <CancelButton
                      size="small"
                      onClick={() => {
                        // ✅ Demo/Real 자동 선택
                        if (item?.status == 10) {
                          const temp = mitdata[
                            'MIT' + item?.exchange_pairs_id
                          ]?.filter(
                            (mit: any) =>
                              !(
                                mit.limit_market == 'C' + item?.limit_market &&
                                +mit.price == +item?.order_price &&
                                mit.longshort == item?.long_short
                              )
                          );

                          mutateMit(temp, item?.exchange_pairs_id);

                          cancelOrderNoLogout({
                            orderid: item?.id,
                            is_triggered: !!item?.trigger_type,
                          })
                            .then((res) => {
                              mutate();
                              message.success(
                                t(
                                  item?.limit_market == 'L'
                                    ? 'climit'
                                    : 'cmarket'
                                ) + t('successOrderCancelled')
                              );
                            })
                            .catch((err) => {
                              message.error(t('failedToCancelOrder'));
                            });
                        } else {
                          cancelOrderNoLogout({
                            orderid: item?.id,
                          })
                            .then((res) => {
                              mutate();
                              message.success(t('successOrderCancelled'));
                            })
                            .catch((err) => {
                              message.error(t('failedToCancelOrder'));
                            });
                        }
                      }}
                    >
                      {t('cancel')}
                    </CancelButton>
                  </div>
                );
              },
            },
          ]}
          pagination={false}
          style={{ width: '100%', height: '100%' }}
          sticky={true}
          scroll={
            isMobile
              ? { x: 'max-content', y: '100%' }
              : needsScroll
                ? {
                    x: 'max-content',
                    y: parentHeight - 20 - (headerHeight || 38),
                  }
                : {
                    x: 'max-content',
                  }
          }
          size="small"
        />
      ) : (
        <View
          style={{
            flex: 1,
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isMobile ? (
            <CNoDataFound
              noDataTitle={'currentPositionTitle'}
              noDataContent={undefined}
              noDataSize={undefined}
              noDataHeight={'180px'}
              lottieSize={undefined}
            />
          ) : (
            <EmptyPosition type="order" />
          )}
        </View>
      )}
    </TradeDetailListSection>
  );
};

export default TradeActiveTable;
